import { render, staticRenderFns } from "./CompletedWork.vue?vue&type=template&id=17c848dc&scoped=true"
import script from "./CompletedWork.vue?vue&type=script&lang=js"
export * from "./CompletedWork.vue?vue&type=script&lang=js"
import style0 from "./CompletedWork.vue?vue&type=style&index=0&id=17c848dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c848dc",
  null
  
)

export default component.exports